// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"kf-z","itemsContainer":"lf-z"};